import { createContext, useContext, useEffect, useState } from 'react';

// Carries the create-time PDF chosen in the dialog's right-pane picker down to
// the save mutation, which uploads it against the new invoice id after create —
// without threading the File through every form layer.
export interface InvoiceCreatePdfState {
  readonly file: File | null;
}

const InvoiceCreatePdfContext = createContext<InvoiceCreatePdfState>({ file: null });

export const InvoiceCreatePdfProvider = InvoiceCreatePdfContext.Provider;

export function useInvoiceCreatePdf(): InvoiceCreatePdfState {
  return useContext(InvoiceCreatePdfContext);
}

// Holds the create-time PDF for a dialog, clearing it whenever the dialog
// closes. An `initial` file (e.g. the PDF an AI extraction ran on) seeds the
// pane when the dialog opens; the operator can still replace or remove it.
export function useCreatePdfFileState(
  open: boolean,
  initial: File | null = null,
): readonly [File | null, (f: File | null) => void] {
  const [file, setFile] = useState<File | null>(null);
  useEffect(() => {
    setFile(open ? initial : null);
  }, [open, initial]);
  return [file, setFile];
}
